export const parseJSONObject = (str: string) => {
  try {
    const obj = JSON.parse(str);
    return typeof obj === 'object' ? obj : {};
  } catch {
    return {};
  }
};
